export enum BotRegion {
    EU_WEST = 'eu-west',
    US_EAST = 'us-east'
}